module.exports = __webpack_public_path__ + "static/media/heart.3016a1dc.svg";